import { useMemo } from "react";
import { SPRest } from "@pnp/sp";
import { useScopedService } from "../contexts";
import { PnpClientProvider } from "@excentone/spfx-core-lib";

/**
 * `useSpClient` returns the SharePoint API Client instance registered in the service scope.
 * @returns The `SPRestClient` instance.
 */
export const useSpClient = (): SPRest => {
  const clientProvider = useScopedService(PnpClientProvider.serviceKey);
  return useMemo((): SPRest => clientProvider && clientProvider.sp, [clientProvider]);
};